module.exports = __webpack_public_path__ + "static/dell-xps-15@2x-ee3b63d35934c0ddeae6d0aa0e12c4e9.png";